/**
 * TipoRelatorio
 * @author ftgibran
 */
export enum TipoRelatorio {
  DELIVERY_FULL_CSV = 1,
  DELIVERY_FULL_XLSX,
  DELIVERY_SIMPLE_CSV,
  DELIVERY_SIMPLE_XLSX,
}
